import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function SteamBlueIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("h-6 w-6", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.32543 14.3002C5.31371 17.5968 8.37082 19.9986 11.989 19.9986C16.4068 19.9986 19.9883 16.4171 19.9883 11.9993C19.9883 7.58142 16.4068 4 11.989 4C7.74969 4 4.2808 7.29784 4.00684 11.4678C4.52456 12.3371 4.7265 12.8748 4.3255 14.3002H4.32543Z"
        fill="url(#paint0_linear_12834_36151)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5777 10.036C11.577 10.0233 11.577 10.0099 11.577 9.99643C11.577 8.31829 12.94 6.95312 14.6154 6.95312C16.2915 6.95312 17.6538 8.31829 17.6538 9.99643C17.6538 11.6744 16.2915 13.0408 14.6154 13.0408C14.5927 13.0408 14.5694 13.0402 14.5467 13.0395L11.746 15.041C11.7542 15.35 11.6972 15.6597 11.575 15.9549C11.1053 17.0844 9.80353 17.6221 8.67449 17.1504C7.98443 16.8627 7.51669 16.2646 7.36412 15.5828L4.32548 14.329C3.91103 13.1095 4.01045 11.4732 4.01045 11.4732L8.30872 13.2427C8.42685 13.1648 8.5523 13.0985 8.68328 13.045C8.98499 12.9207 9.30318 12.8651 9.62027 12.8795L11.5777 10.036ZM8.86931 16.6822C9.74107 17.0454 10.744 16.6314 11.1075 15.7587C11.2832 15.3371 11.2839 14.8702 11.1102 14.4472C10.9365 14.0242 10.6087 13.6933 10.1862 13.5175C9.76716 13.3431 9.31865 13.3486 8.92411 13.4983L9.94658 13.9219C10.5891 14.1897 10.8932 14.9285 10.6252 15.5719C10.3579 16.2146 9.62035 16.5195 8.97746 16.2517L7.98836 15.8417C8.16352 16.2077 8.46715 16.5146 8.86931 16.6822ZM14.6154 12.0246C13.4997 12.0246 12.5912 11.1148 12.5912 9.99637C12.5912 8.87887 13.4997 7.9688 14.6154 7.9688C15.7319 7.9688 16.6403 8.87887 16.6403 9.99637C16.6403 11.1148 15.7319 12.0246 14.6154 12.0246ZM14.6188 8.46881C13.7798 8.46881 13.0986 9.15118 13.0986 9.99252C13.0986 10.8339 13.7798 11.5157 14.6188 11.5157C15.4586 11.5157 16.1397 10.8339 16.1397 9.99252C16.1397 9.15118 15.4586 8.46881 14.6188 8.46881Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12834_36151"
          x1="4.00684"
          y1="4"
          x2="4.00684"
          y2="19.9986"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#111D2E" />
          <stop offset="0.212" stopColor="#051839" />
          <stop offset="0.407" stopColor="#0A1B48" />
          <stop offset="0.581" stopColor="#132E62" />
          <stop offset="0.738" stopColor="#144B7E" />
          <stop offset="0.873" stopColor="#136497" />
          <stop offset="1" stopColor="#1387B8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
